import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/profile")({
  validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
    tab: (search.tab as string) || undefined,
  }),
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: "/login" })
  },
})
